import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material'
import AutorenewIcon from '@mui/icons-material/Autorenew'
import CloseIcon from '@mui/icons-material/Close'
import { useTranslation } from 'react-i18next'
import { useContext } from 'react'
import { VehiclePhotoDialogDispatchContext } from '.'

const PhotoEditDrawer = ({ open }) => {
  const vehiclePhotoDialogDispatch = useContext(
    VehiclePhotoDialogDispatchContext
  )
  const handlePhotoEditDrawerClose = () =>
    vehiclePhotoDialogDispatch.setVehiclePhotoDialog({ open: false })
  const { t } = useTranslation()
  return (
    <Drawer anchor="bottom" open={open} onClose={handlePhotoEditDrawerClose}>
      <List>
        <ListItem
          button
          component="label"
          htmlFor="upload-photo-img"
          onClick={handlePhotoEditDrawerClose}
        >
          <ListItemIcon sx={{ color: '#000' }}>
            <AutorenewIcon />
          </ListItemIcon>
          <ListItemText primary={t('vehicle_photos.change_photo')} />
        </ListItem>
        <ListItem button onClick={handlePhotoEditDrawerClose}>
          <ListItemIcon sx={{ color: '#000' }}>
            <CloseIcon />
          </ListItemIcon>
          <ListItemText primary={t('common.cancel')} />
        </ListItem>
      </List>
    </Drawer>
  )
}

export default PhotoEditDrawer
